import {Button, Pagination, Table, Tabs, Tag as AntdTag} from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import Spinner from '../../components/Spinner/Spinner';
import { TabStatus} from './BackofficeLNLMAttendants.model';
import styles from './BackofficeLNLMAttendants.module.scss';
import {useRef} from "react";
import useLNLMAttendants  from "./useBackofficeLNLMAttendants";
import Popup from "../../components/Popup/Popup";
import Icon from "../../components/Icon/Icon";
import {useAuthenticationDataContext} from "../../Helpers/AuthenticationDataProvider";
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';

const Attendants = () => {
	
	const {
		getUsers,
		onChangeUsersPagination,
		onExportAttendants,
		state,
		setCsvFile,
		toggleExportPopup,
		toggleImportPopup
	} = useLNLMAttendants();

	const { email } = useAuthenticationDataContext();

	const {
		attendants,
		exportPopup,
		importPopup,
		pagination,
		tabStatus,
	} = state;

	const intl = useIntl();
	const { TabPane } = Tabs;
	const inputFile = useRef<any>(null)
	
	const columnsUsers = [
		{
			dataIndex: 'name',
			title: intl.formatMessage({ id: 'table.column.name' }),
		},
		{
			dataIndex: 'email',
			title: intl.formatMessage({ id: 'table.column.primaryEmail' }),
		},
		{
			dataIndex: 'secondaryEmail',
			title: intl.formatMessage({ id: 'table.column.secondaryEmail' }),
		},
		{
			dataIndex: 'conference',
			title: intl.formatMessage({ id: 'table.column.conference' }),
		},
	];

	const onImportFile = () => {
		inputFile?.current?.click();
	};
	
	const renderTabBarExtraContent  = {
		right: (
			<div className={styles.tabBarExtraContent}>
				<Button type="primary" onClick={onImportFile}><FormattedMessage id="buttons.importAttendants" /></Button>
				<input type='file' id='file' accept=".csv" ref={inputFile} style={{display: 'none'}} onChange={(e) => {setCsvFile(e?.target?.files?.[0])}}/>
				<Button onClick={onExportAttendants}><FormattedMessage id="buttons.exportCSVtoMail" /></Button>
			</div>
		)
	};

	return (
		<div className={styles.pageContainer}>
			<div className={styles.pageContent}>
				<div className={styles.tabBarExtraContentMobile}>
					<Button type="primary" onClick={onImportFile}><FormattedMessage id="buttons.importAttendants" /></Button>
					<input type='file' id='file' accept=".csv" ref={inputFile} style={{display: 'none'}} onChange={(e) => {setCsvFile(e?.target?.files?.[0])}}/>
					<Button onClick={onExportAttendants}><FormattedMessage id="buttons.exportCSVtoMail" /></Button>
				</div>
		<Tabs
			className={`navigator ${styles.content}`}
			defaultActiveKey="1"
			tabBarExtraContent={renderTabBarExtraContent}
		>
			<TabPane
				tab={
					<>
						<FormattedMessage id="navigation.attendants" />
					</>
				}
				key="1"
			>
				<div className={styles.tabContent}>
					<Spinner spinning={tabStatus === TabStatus.Loading} />
					<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getUsers} showReport={false}/>
					<div className={styles.table}>
						<Table
							columns={columnsUsers}
							dataSource={attendants}
							pagination={false}
							rowKey={record => record.key}
						/>
				</div>
					<div className={styles.contentMobile}>
						{attendants?.map((attendant) => {
							return (
								<div className={styles.card}>
									<div className={styles.cardContainer}>
										<div>
											<div className={styles.row}>
												<h2 className={styles.label}>
													<FormattedMessage id="table.column.name" />
												</h2>
												<span className={styles.mobileResourceName}>
													{attendant.name}
												</span>
											</div>
											<div>
												<h2 className={styles.label}>
													<FormattedMessage id="table.column.primaryEmail" />
												</h2>
												<span>{attendant.email}</span>
											</div>
											{attendant.secondaryEmail &&
												<div>
													<h2>
														<FormattedMessage id="table.column.secondaryEmail" />
													</h2>
													<span>{attendant.secondaryEmail}</span>
												</div>
											}
											<div >
												<h2>
													<FormattedMessage id="table.column.conference" />
												</h2>
												<span>{attendant.conference}</span>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
					<div className={styles.paginationWrapper}>
						<Pagination
							className={styles.pagination}
							current={pagination.page}
							total={pagination.total}
							onChange={onChangeUsersPagination}
							showSizeChanger={false}
						/>
					</div>
				</div>
			</TabPane>
		</Tabs>
			</div>
			{exportPopup && <Popup onClose={toggleExportPopup} size="small">
				<div className={styles.popupContent}>
					<Icon name="paper-plane" width="64px" height="64px" color="accent" />
					<p><FormattedMessage id="statistics.export.info" values={{ email }}/></p>
				</div>
			</Popup>}
			{importPopup && <Popup onClose={toggleImportPopup} size="small">
				<div className={styles.popupContent}>
					<Icon name="info" width="64px" height="64px" color="accent" />
					<p><FormattedMessage id="attendants.importInfo" /></p>
				</div>
			</Popup>}
		</div>
	);
};

export default Attendants;